import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { TSDUploadDownloadHouseItemsData } from '@e-origin/contracts';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '../../utils';

export const useTsdDownloadHouseConsignmentItems = () => {
  return useMutation({
    mutationFn: async ({ tsdId, houseConsignmentIndex, tsdName }: TSDUploadDownloadHouseItemsData) => {
      // todo: find way to use apuClient instead
      // const response = await apiClient.tsd.downloadHouseItems.query({
      //   params: { tsdId, houseConsignmentIndex },
      //   responseType: 'arraybuffer',
      // });
      const response = await request({
        path: `tsd/${tsdId}/${houseConsignmentIndex}/download-house-items`,
        method: 'GET',
        authenticate: true,
        responseType: 'arraybuffer',
      });

      const url = window.URL.createObjectURL(new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${tsdName}-houseConsignment-${houseConsignmentIndex}.xlsx`);
      document.body.appendChild(link);
      link.click();
    },
    onSuccess: () => {
      toast.success('Successfully downloaded the list!');
    },
    onError: (error) => {
      showErrorToast(error, `Error downloading the house consignment items!`);
    },
  });
};
